(function () {
  'use strict';

  angular
      .module('tfc.Files')
      .factory('Month', Month);

  // @ngInject
  function Month() {

    var MONTHS = [
      'jan',
      'feb',
      'mar',
      'apr',
      'may',
      'jun',
      'jul',
      'aug',
      'sep',
      'oct',
      'nov',
      'dec'
    ];

    return {
      getMonth : getMonth,
      toInt : toInt
    };

    function getMonth(date) {
      if (date instanceof Date) {
        return getMonth(date.getMonth() + 1);
      } else {
        return MONTHS[date - 1];
      }
    }

    function toInt(month) {
      var index = MONTHS.indexOf(month);
      if (~index) {
        return index + 1;
      }
    }

  }

})();
